import React from 'react';

const Footer = () => {
  return (
    <div className="ui inverted vertical footer segment">
      <div className="ui center aligned container">
        <div className="ui horizontal inverted small divided link list">
          <a className="item" href="https://www.evilhat.com/home/monster-of-the-week/">Monster of the Week</a>
          <a className="item" href="https://buymeacoffee.com/monsterbot">Buy Me a Coffee</a>
          <a className="item" href="/terms.html">Terms of Service</a>
          <a className="item" href="/privacy.html">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
